import { CheckCircle2, XCircle, Info } from "lucide-react";
import { useToastStore, type ToastTone } from "@/stores/toast.store";
import { cn } from "@/lib/cn";

const TONE_STYLES: Record<ToastTone, string> = {
  success: "border-l-4 border-l-success text-success",
  error: "border-l-4 border-l-danger text-danger",
  info: "border-l-4 border-l-primary text-primary",
};

const ICONS: Record<ToastTone, typeof Info> = {
  success: CheckCircle2,
  error: XCircle,
  info: Info,
};

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    // Mobile : pleine largeur en bas (un long message ne déborde plus à droite).
    <div className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:bottom-5 sm:end-5 z-[3000] flex flex-col items-stretch sm:items-end gap-2">
      {toasts.map((t) => {
        const Icon = ICONS[t.tone];
        return (
          <button
            key={t.id}
            onClick={() => dismiss(t.id)}
            className={cn(
              "flex items-center gap-2.5 bg-card border border-border rounded max-w-full sm:max-w-[380px] px-4 py-3 sm:px-5 sm:py-4 text-[13px] text-text shadow-floating animate-slideIn text-left",
              TONE_STYLES[t.tone],
            )}
          >
            <Icon className="h-4 w-4 shrink-0" />
            <span className="text-text">{t.message}</span>
          </button>
        );
      })}
    </div>
  );
}
